'use client';

import { useTranslations } from 'next-intl';

import { DiscountBadge } from '@/app/[locale]/products/[slug]/components/ProductBadges/DiscountBadge';
import { useShowPdpFreeShippingMessaging } from '@/components/USFreeShippingBanner/useShowPdpFreeShippingMessaging';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function FreeShippingBadge() {
  const t = useTranslations('common');
  const [authenticated] = useCurrentUser();
  const showMessaging = useShowPdpFreeShippingMessaging();

  if (!authenticated || !showMessaging) {
    return null;
  }

  return <DiscountBadge label={t('USFreeShippingBanner.Badge')} />;
}
